import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import { getAppCfg, getBrowser, getCountryDefault, getLanguage, getSourceInfo } from '../../utils/common';
import RegisterVerificationView from '../register/RegisterVerificationView';
import CredentialsController from '../identify/CredentialsController';
import RegisterExistingView from './RegisterExistingView';
import { paths } from '../../../portal.router.config';
import crmservices from '../../wsclient/';

const styles = theme => ({

});

function RegisterExistingController(props) {
    const config = getAppCfg()
    let agreement_countries = config && config.contact && config.contact.agreement_countries ? config.contact.agreement_countries : null
    let country_default = getCountryDefault(agreement_countries);

    const [active, setActive] = useState('main');
    const [method_select, onSelectMethod] = useState('PHONE');
    const [verify_type, onSelectVerify] = useState('EMAIL');
    const [showLoading, onShowLoading] = useState(false);
    const [error, setError] = useState({});
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState('');
    const [contact, setContact] = useState(null);
    const [register_info, setRegisterInfo] = useState({
        email: getSourceInfo() && getSourceInfo().email ? getSourceInfo().email : null,
        phone: getSourceInfo() && getSourceInfo().phone ? getSourceInfo().phone : null,
    });
    const [auth_support, setAuthSupport] = useState('LOYALTY_IDENTIFIER');

    const onRegister = async (values) => {
        console.log('register info values === ', values);
        setRegisterInfo({
            ...register_info,
            contact_code: values.contact_code,
            email: values.email,
            password: values.password
        });
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.sendCredentialsOTP({
                send_method: 'EMAIL',
                name: auth_support,
                value: values.contact_code,
            });
            console.log("result sendCredentialsOTP==", result);
            if (result.code == 'OK') {
                setActive('verify');
            } else {
                console.log("error sendCredentialsOTP:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            console.log("register by phone exception:", error);
            showAlert('ERROR', t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }

    const onVerifyOTP = async (code) => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.validateOTP({
                phone: null,
                auth_otp: auth_support,
                otp: code.verification_code
            });
            if (result.code == 'OK') {
                setContact(result.data);
                await onCredentials();
            } else {
                console.log("error sendCredentialsOTP:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const onCredentials = async () => {
        try {
            let jwtDecode = require('jwt-decode');
            let contact_id = null;
            let language_code = getLanguage();
            const access_token = contact && contact.access_token ? contact.access_token : null
            if (access_token) {
                contact_id = jwtDecode(access_token).sub
                console.log('jwtDecode(access_token)===', jwtDecode(access_token))
            }
            if (!contact_id) {
                showAlert('ERROR', t('Can not access token'))
                return;
            }
            let result = await crmServices.contacts.credentialsByEmail(register_info.email, register_info.password, contact_id, access_token, false, language_code);
            if (result.code == 'OK') {
                showAlert('SUCCESS', t('REGISTER_EMAIL_SUCCESS'));
                onAuthCredentials();
            } else if (result.code === 'INVALID_CONTACTPASSWORD_EXCEPTION') {
                showAlert('ERROR', t('INVALID_CONTACTPASSWORD_EXCEPTION'));
            } else {
                console.log("error sendCredentialsOTP:", result.code);
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
    }

    const onResendCode = async () => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.sendCredentialsOTP({ send_method: verify_type, name: method_select, value: 'EMAIL' });
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp)
                }
                if (verify_type === 'email')
                    showAlert('ERROR', t('OTP_RESEND_EMAIL_SUCCESS'));
                else
                    showAlert('ERROR', t('OTP_RESEND_SUCCESS'));

            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const showAlert = async (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }

    const onCloseAlert = async () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }

    const onAuthCredentials = () => {
        props.history.push(paths.login);
    }

    return (
        <div>
            {active === 'main' && <RegisterExistingView
                onSubmit={onRegister}
                showAlert={showAlert}
                onShowLoading={onShowLoading}
                onSelectVerify={onSelectVerify}
                onSelectMethod={onSelectMethod}
                agreement_countries={agreement_countries}
            />}
            {active === 'verify' && <RegisterVerificationView
                onSubmit={onVerifyOTP}
                onResend={onResendCode}
                obfuscated_value={obfuscated_value}
                email={verify_type === 'EMAIL'} />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            {showLoading && <Loading showLoading={showLoading} />}
        </div>

    );
}

export default withStyles(styles)(withTranslation()(RegisterExistingController));